/**
 * Blog Hub Promo — newsletter form validation, scoped server feedback, submit loading
 */

(function() {
  'use strict';

  var STORAGE_KEY = 'blogHubPromoFormSource';
  var DEFAULT_TERMS_MESSAGE = 'Please agree to Terms of Use and Privacy Policy.';

  function initPromoForm(formRoot) {
    if (!formRoot || formRoot._blogHubPromoInitialized) {
      return;
    }

    var sectionId = formRoot.getAttribute('data-section-id');
    var form = formRoot.querySelector('.blog-hub-promo__signup-form');
    var emailInput = formRoot.querySelector('[data-blog-hub-promo-email]');
    var termsCheckbox = formRoot.querySelector('[data-blog-hub-promo-terms]');
    var submitButton = formRoot.querySelector('button[type="submit"]');
    var clientError = formRoot.querySelector('[data-blog-hub-promo-client-error]');
    var clientErrorText = formRoot.querySelector('[data-blog-hub-promo-client-error-text]');
    var serverSuccess = formRoot.querySelector('[data-blog-hub-promo-server-success]');
    var serverError = formRoot.querySelector('[data-blog-hub-promo-server-error]');
    var termsMessage = formRoot.getAttribute('data-blog-hub-promo-terms-message') || DEFAULT_TERMS_MESSAGE;

    var termsRow = formRoot.querySelector('.blog-hub-promo__form-terms');

    if (!form || !emailInput || !termsCheckbox || !sectionId) {
      return;
    }

    function hideServerMessage(node) {
      if (!node) return;
      node.hidden = true;
      node.setAttribute('hidden', '');
    }

    function showServerMessage(node) {
      if (!node) return;
      node.hidden = false;
      node.removeAttribute('hidden');
    }

    function clearServerFeedback() {
      hideServerMessage(serverSuccess);
      hideServerMessage(serverError);
      emailInput.removeAttribute('aria-describedby');
      emailInput.removeAttribute('aria-invalid');
    }

    function initServerFormState() {
      var submittedSection = sessionStorage.getItem(STORAGE_KEY);

      if (submittedSection === sectionId) {
        sessionStorage.removeItem(STORAGE_KEY);

        if (serverSuccess) {
          showServerMessage(serverSuccess);
          emailInput.setAttribute('aria-describedby', serverSuccess.id);
        }

        if (serverError) {
          showServerMessage(serverError);
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.setAttribute('aria-describedby', serverError.id);
        }

        return;
      }

      hideServerMessage(serverSuccess);
      hideServerMessage(serverError);
    }

    function hideClientError() {
      if (!clientError) return;
      clientError.hidden = true;
      clientError.setAttribute('hidden', '');
      if (termsRow) termsRow.classList.remove('is-error');
    }

    function showClientError(message, highlightTerms) {
      if (!clientError || !clientErrorText) return;
      clientErrorText.textContent = message;
      clientError.hidden = false;
      clientError.removeAttribute('hidden');
      if (termsRow) {
        termsRow.classList.toggle('is-error', !!highlightTerms);
      }
      clientError.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function setLoading(isLoading) {
      if (!submitButton) return;
      submitButton.classList.toggle('is-loading', isLoading);
      submitButton.disabled = isLoading;
      submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function validateTerms() {
      if (termsCheckbox.checked) {
        return true;
      }

      showClientError(termsMessage, true);
      termsCheckbox.focus();
      return false;
    }

    function validateEmail() {
      if (emailInput.checkValidity()) {
        return true;
      }

      showClientError(emailInput.validationMessage, false);
      emailInput.focus();
      return false;
    }

    function markFormSubmitted() {
      sessionStorage.setItem(STORAGE_KEY, sectionId);
      setLoading(true);
    }

    function handleSubmit(event) {
      clearServerFeedback();
      hideClientError();

      if (!validateTerms()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (!validateEmail()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      markFormSubmitted();
    }

    initServerFormState();

    emailInput.addEventListener('input', hideClientError);
    termsCheckbox.addEventListener('change', hideClientError);

    form.addEventListener('submit', handleSubmit, true);

    if (submitButton) {
      submitButton.addEventListener('click', function(event) {
        clearServerFeedback();

        if (!termsCheckbox.checked) {
          event.preventDefault();
          handleSubmit(event);
        }
      });
    }

    formRoot._blogHubPromoInitialized = true;
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-blog-hub-promo-form]').forEach(initPromoForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
    });
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      initAll(event.target);
    });
  }
})();
